import { PageType } from 'api/page-template/types';
import { useMemo } from 'react';
import {
  useGetDefaultAiSectionCommands,
  useGetDefaultMeetingBlockCommands,
} from './default-ai-section-commands';
import { useGetDefaultFormattingCommands } from './formatting-commands';
import { useGetImageCommand } from './image-command';
import { useGetTemplateSectionsCommands } from './meeting-template-sections';
import { CommandPickerItem } from '../types';

export const useDefaultCommands = ({
  pageType,
  documentId,
}: {
  pageType?: PageType;
  documentId?: number;
}): {
  items: CommandPickerItem[];
  isLoading: boolean;
} => {
  const formattingCommands = useGetDefaultFormattingCommands();
  const aiSectionCommands = useGetDefaultAiSectionCommands();
  const meetingBlockCommands = useGetDefaultMeetingBlockCommands();
  const imageCommands = useGetImageCommand({ documentId });
  const meetingTemplateSectionsCommands = useGetTemplateSectionsCommands({
    pageType: pageType,
  });

  return useMemo(
    () => ({
      items: [
        ...aiSectionCommands,
        ...meetingBlockCommands,
        ...meetingTemplateSectionsCommands.items,
        ...formattingCommands,
        ...imageCommands,
      ],
      isLoading: meetingTemplateSectionsCommands.isLoading,
    }),
    [
      aiSectionCommands,
      meetingBlockCommands,
      formattingCommands,
      imageCommands,
      meetingTemplateSectionsCommands,
    ],
  );
};
